import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getPrepaids,
    createPrepaid,
    updatePrepaid,
    deletePrepaid
}

function getPrepaids(userId, type = '') {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/prepaids`)
           .set('access', Storage.getItem('access'))
           .query({userId, type})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createPrepaid(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/prepaids`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updatePrepaid(prepaidId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/prepaids/${prepaidId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deletePrepaid(prepaidId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/prepaids/${prepaidId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}